import { css } from 'styled-components';
/** TODO: Remove */ export const PrivateStyles = css`
  --action-bar-background: var(--private-02);
  --rte-background: var(--private-02);

  background: var(--private-02);

  &:hover {
    --rte-background: var(--private-01);

    background: var(--private-01);
  }
`;
